module.exports = __webpack_public_path__ + "static/media/03.899e3f4b.png";